import {DialogService} from '../../../core/services/dialog.service';
import {DialogKey} from '../dialogs/dialogs-configuration';

export class BannerBase {

    get logoSos(): string {
        return './assets/images/banners/logo_sos.png';
    }

    constructor(public dialogService: DialogService) {

    }

    openPopup() {
        this.dialogService.open(DialogKey.DRIVER_SOS_DETAILS);
    }
}
